import React from 'react';

// helpers
import {useTranslation} from 'react-i18next';
import {formatCurrency} from '../../../../../../shared/helpers';

// components
import {Button} from '@mui/joy';
import {
  CardBorder,
  LabelContentHorizontal,
} from '../../../../../../shared/components';

// styles
import {CardCashbackRequestWrapper} from './CardCashbackRequest-styles';
import {TextColors, TextDefault} from '../../../../../../shared/styles';

// types
import {CashbackRequest} from '../../../../../../shared/services/ApiService/types';

type Props = {
  cashbackRequest: CashbackRequest;
};

const CardCashbackRequest = ({cashbackRequest}: Props) => {
  const {t} = useTranslation();

  /**
   * Open a new tab with the given URL
   * @param url
   */
  const goToPage = (url: string) => () => {
    window.open(url, '_blank');
  };

  return (
    <CardBorder variant="white">
      <CardCashbackRequestWrapper>
        <LabelContentHorizontal
          label={t('global_status')}
          content={cashbackRequest.status}
        />
        <LabelContentHorizontal
          label={t('subscription_amountRequested')}
          content={formatCurrency(cashbackRequest.amount)}
        />
        {cashbackRequest.ibvUrl && (
          <Button
            size="lg"
            variant="outlined"
            onClick={goToPage(cashbackRequest.ibvUrl)}>
            <TextDefault bold="bold" color={TextColors.brand}>
              {t('instant_banking_verification')}
            </TextDefault>
          </Button>
        )}
        {cashbackRequest.contractUrl && (
          <Button
            size="lg"
            variant="outlined"
            onClick={goToPage(cashbackRequest.contractUrl)}>
            <TextDefault bold="bold" color={TextColors.brand}>
              {t('contract')}
            </TextDefault>
          </Button>
        )}
      </CardCashbackRequestWrapper>
    </CardBorder>
  );
};

export default CardCashbackRequest;
